
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-5'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            제품 관리 - 제품 {{ $route.query.product_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.product_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='brand_ID'>브랜드<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="brand_ID"
                v-model="formData.brandID"
              >
                <option
                  v-for="item in statusData.brandIDArray"
                  :key="item.brand_ID"
                  :value="item.brand_ID"
                >
                  {{ item.brand_kor_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_type_ID'>제품 타입(1단계)<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_type_ID"
                v-model="formData.productTypeID"
                v-on:change="change_product_type"
              >
                <option
                  v-for="item in statusData.productTypeIDArray"
                  :key="item.product_type_ID"
                  :value="item.product_type_ID"
                >
                  {{ item.product_type_kor_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_division_one_level_ID'>제품 분류(2단계)<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_division_one_level_ID"
                v-model="formData.productDivisionOneLevelID"
                v-on:change="change_product_division_one"
              >
                <option
                  v-for="item in statusData.productDivisionOneLevelIDArray"
                  :key="item.product_division_one_level_ID"
                  :value="item.product_division_one_level_ID"
                >
                  {{ item.product_division_one_level_kor_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div :class="statusData.productDivisionTwoLevelIDArray.length === 0 ? 'display_none' : 'Admin_PageDetail_BoxDiv'">
              <label for='product_division_two_level_ID'>제품 분류(3단계)<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_division_two_level_ID"
                v-model="formData.productDivisionTwoLevelID"
              >
                <option
                  v-for="item in statusData.productDivisionTwoLevelIDArray"
                  :key="item.product_division_two_level_ID"
                  :value="item.product_division_two_level_ID"
                >
                  {{ item.product_division_two_level_kor_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_kor_name'>한글명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_kor_name'
                maxLength="100"
                placeholder = "한글명을 입력해 주세요."
                v-model="formData.productKorName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productKorNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_eng_name'>영문명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_eng_name'
                maxLength="100"
                placeholder = "영문명을 입력해 주세요."
                v-model="formData.productEngName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productEngNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_inventory'>재고수량<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_inventory'
                maxLength="4"
                placeholder = "재고수량을 입력해 주세요."
                v-model="formData.productInventory"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productInventoryError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_sale_price'>가격<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_sale_price'
                maxLength="13"
                placeholder = "가격을 입력해 주세요."
                v-model="formData.productSalePrice"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productSalePriceError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_discount'>할인금액<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_discount'
                maxLength="13"
                placeholder = "할인금액을 입력해 주세요."
                v-model="formData.productDiscount"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productDiscountError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_phone_inquiry_status'>센텀점 문의<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_phone_inquiry_status"
                v-model="formData.productPhoneInquiryStatus"
              >
                <option value='0'>미적용</option>
                <option value='1'>적용</option>
              </select>
            </div>
            <div class="Admin_PageDetail_addInfo">
              *센텀점 문의 적용 시 가격 및 옵션이 노출되지 않으며, "센텀점 문의"만 노출됩니다.
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_note_title'>비고명</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'product_note_title'
                maxLength="100"
                placeholder = "비고명을 입력해 주세요."
                v-model="formData.productNoteTile"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productNoteTileError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_activate'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_activate"
                v-model="formData.productActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label>화면 표시<span class="pointTextRed"> * </span></label>
              <div class="Admin_sectionBox_infoTagWrap">
                <div>
                  <label for="product_new" class="sectionBox_infoTag_new">
                    New
                  </label>
                  <select
                    id="product_new"
                    v-model="formData.productNew"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>

                <div>
                  <label for="product_in_stock" class="sectionBox_infoTag_inStock">재고보유</label>
                  <select
                    id="product_in_stock"
                    v-model="formData.productInStock"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
                <div>
                  <label for="product_best" class="sectionBox_infoTag_best">Best</label>
                  <select
                    id="product_best"
                    v-model="formData.productBest"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
                <div>
                  <label for="product_sale" class="sectionBox_infoTag_sale">Sale</label>
                  <select
                    id="product_sale"
                    v-model="formData.productSale"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
                <div>
                  <label for="product_expected" class="sectionBox_infoTag_expected">입고예정</label>
                  <select
                    id="product_expected"
                    v-model="formData.productExpected"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
                <div>
                  <label for="product_sold_out" class="sectionBox_infoTag_soldOut">Sold out</label>
                  <select
                    id="product_sold_out"
                    v-model="formData.productSoldOut"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
                <div>
                  <label for="product_event" class="sectionBox_infoTag_event">Event</label>
                  <select
                    id="product_event"
                    v-model="formData.productEvent"
                  >
                    <option value='1'>노출</option>
                    <option value='2'>미노출</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_option_status'>옵션 선택<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_option_status"
                v-model="formData.productOptionStatus"
              >
                <option value='0'>개별 옵션 (1개 옵션에 개별 리스트 및 옵션 설정)</option>
                <option value='1'>그룹 옵션 (그룹 옵션에 서로 연동되는 리스트 및 옵션 설정)</option>
              </select>
            </div>
            <div class="Admin_PageDetail_addInfo">
                *개별 옵션 / 그룹 옵션 중 1개 선택하여 아래에서 해당 옵션 리스트를 설정할 수 있습니다.
              </div>
          </div>

          <div class="Admin_PageDetail_groupWrap">
            <div class="mgb40"  v-if="formData.productOptionStatus === '1'">
              <div class="Admin_PageDetail_groupWrapTit">
                그룹 옵션 설정
                <span>아래 "그룹 옵션명" 작성 및 해당 그룹의 리스트와 옵션을 추가할 수 있습니다.</span>
              </div>
              <div class="Admin_PageDetail_groupBox_gm">
                <div>
                  <label for='product_group_option_title'>그룹 옵션명<span class="pointTextRed"> * </span></label>
                  <input
                    type='text'
                    id = 'product_group_option_title'
                    maxLength="100"
                    placeholder = "100자 내의 그룹 옵션명을 입력해 주세요."
                    v-model="formData.productGroupOptionTitle"
                  />
                </div>
                <p class="Admin_PageDetail_groupBox_ErrorBox">{{errorData.productGroupOptionTitleError}}</p>
              </div>
              <div>
                <div class="Admin_PageDetail_groupBtn">
                  <p v-on:click="add_product_group_option">
                    리스트 추가
                  </p>
                </div>

                <div class="Admin_PageDetail_groupInfoBox">
                  <p>1. "리스트 추가"를 클릭하여 그룹 리스트를 추가할 수 있습니다.</p>
                  <p>2. 아래 그룹 리스트의 리스트 클릭&amp;드래그하여 순서를 변경할 수 있으며, 보이는 순서대로 홈페이지에 노출됩니다.</p>
                  <p>3. 아래 그룹 리스트의 리스트 클릭하여 상단에서 리스트명을 변경하거나, 하단에서 리스트의 상세 옵션을 설정할 수 있습니다.</p>
                  <p>4. 복사, 삭제 아이콘을 클릭하여 복사, 삭제할 수 있습니다.</p>
                </div>

                <div class="Admin_PageDetail_groupBox_gs displayFlex" v-if="formData.productGroupOptionArray.length > 0">
                  <div class="Admin_PageDetail_groupBox_gsTit">
                    그룹 리스트
                  </div>
                  <div class="Admin_PageDetail_groupBox_gsBox">
                    <div v-if="statusData.selectedTab !== null" class="Admin_PageDetail_groupBox_gs01">
                      <label for="productGroupOptionName">리스트명</label>
                      <input
                        type="text"
                        id="productGroupOptionName"
                        maxLength="100"
                        v-model="formData.productGroupOptionArray[statusData.selectedTab].product_group_option_name"
                        placeholder="100자 내의 리스트명을 입력해주세요."
                      />
                    </div>

                    <draggable v-model="formData.productGroupOptionArray" @end="updateOrder">
                      <div
                        v-for="(option, index) in formData.productGroupOptionArray"
                        :key="option.index"
                        v-if="option.product_group_option_delete_status !== 1"
                        class="Admin_PageDetail_groupBox_gsTab"
                        :class="{ selected: statusData.selectedTab === index }">
                        <div @click="selectTab(index)">
                          <div>
                            <img src="../../../assets/images/icon/icon_menu.png" alt="드래그 아이콘" />
                            <p>{{ option.product_group_option_name || '리스트명을 변경해주세요' }}</p>
                          </div>
                          <div class="Admin_PageDetail_groupBox_gsTabBtn">
                            <button @click="copyGroupOption(index)">복사</button>
                            <button @click="markAsDeleted(index)">삭제</button>
                          </div>
                        </div>
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="Admin_PageDetail_groupWrapTit">
                {{ formData.productOptionStatus === '0' ? '개별 옵션 설정' : (formData.productGroupOptionArray[statusData.selectedTab] ? formData.productGroupOptionArray[statusData.selectedTab].product_group_option_name + ' 옵션 설정' : '리스트의 옵션 설정') }}
                <span>
                  아래 "옵션 추가" 버튼을 클릭하여
                  {{ formData.productOptionStatus === '0' ? '개별 옵션과 리스트를 설정할 수 있습니다.' : (formData.productGroupOptionArray[statusData.selectedTab] ? formData.productGroupOptionArray[statusData.selectedTab].product_group_option_name + '의 세부 옵션을 설정할 수 있습니다.' : '그룹 리스트의 세부 옵션을 설정할 수 있습니다.') }}
                </span>
              </div>

              <div class="Admin_PageDetail_groupBtn">
                <p v-on:click="add_product_option">옵션 추가</p>
              </div>

              <div
                class="Admin_PageDetail_groupBox"
                v-for="(item, index) in filteredProductOptionArray"
                v-if="item.product_option_delete_status === 0"
                :key="index"
              >
                <div class="Admin_PageDetail_groupBox_Main">
                  <div class="Admin_PageDetail_groupBtn02">
                    <p v-on:click="delete_product_option(index)">
                      옵션 삭제
                    </p>
                  </div>

                  <div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'product_option_order' + index">순서<span class="pointTextRed"> * </span></label>
                      <input
                        type='text'
                        :id="'product_option_order' + index"
                        maxLength="4"
                        placeholder="순서를 입력해주세요."
                        v-model="item.product_option_order"
                        @input="number_change(index, 'product_option_order')"
                      />
                      <p class="Admin_PageDetail_groupBox_ErrorBox">{{ item.product_option_order_error }}</p>
                    </div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'product_option_name' + index">옵션명<span class="pointTextRed"> * </span></label>
                      <input
                        type='text'
                        :id="'product_option_name' + index"
                        maxLength="100"
                        placeholder="옵션명을 100자 내 입력해주세요."
                        v-model="item.product_option_name"
                      />
                      <p class="Admin_PageDetail_groupBox_ErrorBox">{{ item.product_option_name_error }}</p>
                    </div>
                  </div>
                </div>

                <div class="Admin_PageDetail_groupBox_Sub">
                  <div class="Admin_PageDetail_groupBtn03">
                    <p v-on:click="add_product_option_list(index)">
                      리스트 추가
                    </p>
                  </div>
                  <div
                    class="Admin_PageDetail_groupBox_SubInfo"
                    v-for="(option_list_item, listIndex) in item.product_option_list"
                    v-if="option_list_item.product_option_list_delete_status === 0"
                    :key="listIndex"
                  >
                    <div :class="['Admin_PageDetail_groupBtn04', getRowColor(listIndex)]">
                      <p v-on:click="delete_product_option_list(index, listIndex)">
                        리스트 삭제
                      </p>
                    </div>

                    <div :class="[getRowColor(listIndex)]">
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'product_option_list_order' + listIndex + index">순서<span class="pointTextRed"> * </span></label>
                        <input
                          type='text'
                          :id="'product_option_list_order' + listIndex + index"
                          maxLength="4"
                          placeholder="순서를 입력해주세요."
                          v-model="option_list_item.product_option_list_order"
                          @input="number_change(index, 'product_option_list_order', listIndex)"
                        />
                        <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.product_option_list_order_error }}</p>
                      </div>
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'product_option_list_name' + listIndex">리스트명<span class="pointTextRed"> * </span></label>
                        <input
                          type='text'
                          :id="'product_option_list_name' + listIndex"
                          maxLength="100"
                          placeholder="리스트명을 100자 내로 입력해주세요."
                          v-model="option_list_item.product_option_list_name"
                        />
                        <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.product_option_list_name_error }}</p>
                      </div>
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'product_option_list_plus_sale_price' + listIndex + index">추가금액<span class="pointTextRed"> * </span></label>
                        <input
                          type='text'
                          :id="'product_option_list_plus_sale_price' + listIndex + index"
                          maxLength="10"
                          placeholder="추가 금액을 입력해주세요."
                          v-model="option_list_item.product_option_list_plus_sale_price"
                          @input="number_change(index, 'product_option_list_plus_sale_price', listIndex)"
                        />
                        <p class="Admin_PageDetail_groupBox_ErrorBox">{{ option_list_item.product_option_list_plus_sale_price_error }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">동영상/이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>메인 이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1000 x 1000px</p>
                <label for="product_image" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="image/png, image/gif, image/jpeg"
                  id="product_image"
                  name="'product_image'"
                  @change="change_product_image"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.productImage === '' ? require(`@/assets/images/etc/no_image.gif`) : formData.productImage"
                    alt="대표 제품 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.productImageError}}</p>
              </div>
            </div>

            <!-- "마우스 올렸을 시" 부분 임시로 주석처리함
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>마우스 올렸을 시</p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1000 x 1000px</p>
                <label for="product_image_hover" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="image/png, image/gif, image/jpeg"
                  id="product_image_hover"
                  name="'product_image_hover'"
                  @change="change_product_image_hover"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_Square">
                  <img
                    :src="formData.productImageHover === '' ? require(`@/assets/images/etc/no_image.gif`) : formData.productImageHover"
                    alt="대표 제품 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox"></p>
              </div>
            </div> -->

           <!--  "동영상1" 부분 임시로 주석처리함
           <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>동영상1</p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 자유</p>
                <label for="product_video" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="video/mp4, video/webm, video/ogg"
                  id="product_video"
                  name="product_video"
                  @change="change_product_video"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <video
                    v-if="formData.productVideo"
                    :src="formData.productVideo"
                    controls
                    width="100%"
                    height="auto"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/images/etc/no_image.gif`)"
                    alt="대표 제품 동영상1"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.productVideoError}}</p>
              </div>
            </div> -->

            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>상세 페이지1<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1000 x 세로 자유</p>
                <label for="product_image_detail" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="image/png, image/gif, image/jpeg"
                  id="product_image_detail"
                  name="'product_image_detail'"
                  @change="change_product_image_detail"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.productImageDetail === '' ? require(`@/assets/images/etc/no_image.gif`) : formData.productImageDetail"
                    alt="상세 페이지 이미지1"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.productImageDetailError}}</p>
              </div>
            </div>

            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>동영상</p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 자유</p>
                <label for="product_video_2" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
                <button v-if="formData.productVideo2" class="Admin_imgBanner_BtnDel" @click="delete_product_video_2">삭제</button>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="video/mp4, video/webm, video/ogg"
                  id="product_video_2"
                  name="product_video_2"
                  @change="change_product_video_2"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <video
                    v-if="formData.productVideo2"
                    :src="formData.productVideo2"
                    controls
                    width="100%"
                    height="auto"
                  />
                  <img
                    v-else
                    :src="require(`@/assets/images/etc/no_image.gif`)"
                    alt="대표 제품 동영상2"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.productVideo2Error}}</p>
              </div>
            </div>

            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>상세 페이지2<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1000 x 세로 자유</p>
                <label for="product_image_detail_2" class="Admin_imgBanner_Btn">
                  {{ $route.query.product_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>
              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  accept="image/png, image/gif, image/jpeg"
                  id="product_image_detail_2"
                  name="'product_image_detail_2'"
                  @change="change_product_image_detail_2"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_ProductDetailImg">
                  <img
                    :src="formData.productImageDetail2 === '' ? require(`@/assets/images/etc/no_image.gif`) : formData.productImageDetail2"
                    alt="상세 페이지2 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.productImageDetail2Error}}</p>
              </div>
            </div>
          </div>

          <div class="Admin_PageHeader_btn" style="margin-top:60px;">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.product_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
/* eslint-disable camelcase */
import { ref } from 'vue'
import draggable from 'vuedraggable'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_product_one,
  get_product_group_option,
  get_product_option,
  get_product_option_list,
  insert_product,
  update_product,
  get_product_select_all,
  get_product_division_one_level_one_product_type,
  get_product_division_two_level_one_product_division_one_level,
  base_url_export
} from '../../ETC/Axios.vue'
import {
  removeWhitespace
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminProductManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner,
    draggable: draggable
  },
  setup () {
    return {
      formData: ref({
        brandID: 0,
        productTypeID: 0,
        productDivisionOneLevelID: 0,
        productDivisionTwoLevelID: 0,
        productInventory: '',
        productKorName: '',
        productEngName: '',
        productNoteTile: '',
        productImage: '',
        productImageFile: '',
        productVideo: '',
        productVideoFile: '',
        productVideo2: '',
        productVideoFile2: '',
        productImageHover: '',
        productImageHoverFile: '',
        productImageDetail: '',
        productImageDetailFile: '',
        productImageDetail2: '',
        productImageDetailFile2: '',
        productSalePrice: '',
        productDiscount: '0',
        productPhoneInquiryStatus: 0,
        productActivate: 1,
        productEvent: 2,
        productNew: 2,
        productInStock: 2,
        productBest: 2,
        productSale: 2,
        productExpected: 2,
        productSoldOut: 2,
        productOptionStatus: '0',
        productGroupOptionTitle: '',
        productGroupOptionArray: [],
        productOptionArray: []
      }),
      errorData: ref({
        productKorNameError: '',
        productEngNameError: '',
        productNoteTileError: '',
        productImageError: '',
        productImageDetailError: '',
        productImageDetail2Error: '',
        productSalePriceError: '',
        productDiscountError: '',
        productInventoryError: '',
        productVideoError: '',
        productVideo2Error: '',
        productGroupOptionTitleError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        brandIDArray: [],
        productTypeIDArray: [],
        productDivisionOneLevelIDArray: [],
        productDivisionTwoLevelIDArray: [],
        productOptionIndex: 0,
        productGroupOptionIndex: 0,
        baseUrlExport: base_url_export,
        selectedTab: null
      })
    }
  },
  computed: {
    filteredProductOptionArray: function () {
      if (this.formData.productOptionStatus === '0') {
        return this.formData.productOptionArray
      } else if (this.formData.productOptionStatus === '1' && this.statusData.selectedTab !== null) {
        return this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      }
      return []
    }
  },
  watch: {
    'formData.productSalePrice': function (value) {
      this.formData.productSalePrice = removeWhitespace(value.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    'formData.productDiscount': function (value) {
      this.formData.productDiscount = removeWhitespace(value.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    'formData.productInventory': function (value) {
      this.formData.productInventory = removeWhitespace(value.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    'formData.productOptionStatus': function (value) {
      if (value === '0') {
        get_product_option(
          this.$route.query.product_ID,
          0
        ).then((result_product_option) => {
          this.statusData.productOptionIndex = result_product_option.length
          this.formData.productOptionArray = result_product_option
          get_product_option_list(
            this.$route.query.product_ID,
            0
          ).then((result_product_option_list) => {
            this.formData.productOptionArray.forEach(element => {
              element.product_option_list = []
              result_product_option_list.forEach(element_option_list => {
                if (element.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                  element.product_option_list.push(element_option_list)
                }
              })
              this.$forceUpdate()
            })
          })
        })
      } else {
        get_product_group_option(
          this.$route.query.product_ID
        ).then((result_product_group_option) => {
          this.statusData.productGroupOptionIndex = result_product_group_option.length
          this.formData.productGroupOptionArray = result_product_group_option

          const promises = result_product_group_option.map(async (groupOption, index) => {
            return get_product_option(
              this.$route.query.product_ID,
              groupOption.product_group_option_ID
            ).then((result_product_option) => {
              this.$set(this.formData.productGroupOptionArray[index], 'product_option', result_product_option)
              this.statusData.productOptionIndex += result_product_option.length

              const listPromises = result_product_option.map((option, optionIndex) => {
                return get_product_option_list(
                  this.$route.query.product_ID,
                  groupOption.product_group_option_ID
                ).then((result_product_option_list) => {
                  this.$set(this.formData.productGroupOptionArray[index].product_option[optionIndex], 'product_option_list', [])
                  result_product_option_list.forEach(element_option_list => {
                    if (option.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                      this.formData.productGroupOptionArray[index].product_option[optionIndex].product_option_list.push(element_option_list)
                    }
                  })
                })
              })
              return Promise.all(listPromises)
            })
          })
          Promise.all(promises)
        })
      }
    }
  },
  methods: {
    delete_product_video_2: function () {
      if (confirm('동영상을 삭제하시겠습니까?')) {
        this.formData.productVideo2 = ''
        this.formData.productVideoFile2 = null
        this.errorData.productVideo2Error = ''
      }
    },
    getRowColor (index) {
      const colors = ['color1', 'color2']
      return colors[index % 2]
    },
    change_product_type: function () {
      get_product_division_one_level_one_product_type(
        this.formData.productTypeID
      ).then((result_division_one) => {
        this.statusData.productDivisionOneLevelIDArray = result_division_one
        this.formData.productDivisionOneLevelID = result_division_one[0].product_division_one_level_ID
        get_product_division_two_level_one_product_division_one_level(
          result_division_one[0].product_division_one_level_ID
        ).then((result_division_two) => {
          if (result_division_two.length !== 0) {
            this.statusData.productDivisionTwoLevelIDArray = result_division_two
            this.formData.productDivisionTwoLevelID = result_division_two[0].product_division_two_level_ID
          } else {
            this.statusData.productDivisionTwoLevelIDArray = []
            this.formData.productDivisionTwoLevelID = 0
          }
        })
      })
    },
    change_product_division_one: function () {
      get_product_division_two_level_one_product_division_one_level(
        this.formData.productDivisionOneLevelID
      ).then((result_division_two) => {
        if (result_division_two.length !== 0) {
          this.statusData.productDivisionTwoLevelIDArray = result_division_two
          this.formData.productDivisionTwoLevelID = result_division_two[0].product_division_two_level_ID
        } else {
          this.statusData.productDivisionTwoLevelIDArray = []
          this.formData.productDivisionTwoLevelID = 0
        }
      })
    },
    change_product_image: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productImageFile = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productImage = reader.result
        }
      }
    },
    change_product_image_hover: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productImageHoverFile = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productImageHover = reader.result
        }
      }
    },
    change_product_image_detail: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productImageDetailFile = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productImageDetail = reader.result
        }
      }
    },
    change_product_image_detail_2: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productImageDetailFile2 = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productImageDetail2 = reader.result
        }
      }
    },
    change_product_video: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productVideoFile = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productVideo = reader.result
        }
      }
    },
    change_product_video_2: function (event) {
      if (event.target.files[0] !== undefined) {
        this.formData.productVideoFile2 = event.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onloadend = () => {
          this.formData.productVideo2 = reader.result
        }
      }
    },
    number_change: function (index, column_name, listIndex = 0) {
      let optionArray = this.formData.productOptionStatus === '0' ? this.formData.productOptionArray : this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      if (column_name === 'product_option_order') {
        optionArray[index].product_option_order = removeWhitespace(optionArray[index].product_option_order.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else if (column_name === 'product_option_list_order') {
        optionArray[index].product_option_list[listIndex].product_option_list_order = removeWhitespace(optionArray[index].product_option_list[listIndex].product_option_list_order.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      } else if (column_name === 'product_option_list_plus_sale_price') {
        optionArray[index].product_option_list[listIndex].product_option_list_plus_sale_price = removeWhitespace(
          optionArray[index].product_option_list[listIndex].product_option_list_plus_sale_price.replace(/[^0-9-]/g, '')
        ).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        this.$forceUpdate()
      }
    },
    add_product_group_option: function () {
      let lastOrder = 0
      if (this.formData.productGroupOptionArray.length > 0) {
        lastOrder = Math.max(...this.formData.productGroupOptionArray.map(option => option.product_group_option_order))
      }
      const newOption = {
        product_group_option_ID: 0,
        product_ID_use_product_group_option: 0,
        product_group_option_name: `리스트명${this.statusData.productGroupOptionIndex + 1}`,
        product_group_option_name_error: '',
        product_group_option_order: lastOrder + 1,
        product_group_option_order_error: '',
        product_group_option_delete_status: 0,
        product_option: []
      }
      this.formData.productGroupOptionArray.push(newOption)
      this.statusData.productGroupOptionIndex++
    },
    selectTab: function (index) {
      this.statusData.selectedTab = index
    },
    copyGroupOption: function (index) {
      let lastOrder = 0
      if (this.formData.productGroupOptionArray.length > 0) {
        lastOrder = Math.max(...this.formData.productGroupOptionArray.map(option => option.product_group_option_order))
      }
      const groupToCopy = this.formData.productGroupOptionArray[index]
      const newGroup = JSON.parse(JSON.stringify(groupToCopy))
      newGroup.product_group_option_ID = 0
      newGroup.product_group_option_order = lastOrder + 1
      newGroup.product_option.forEach(option => {
        option.product_option_ID = 0
        option.product_option_list.forEach(list => {
          list.product_option_list_ID = 0
        })
      })
      this.formData.productGroupOptionArray.push(newGroup)
      this.statusData.selectedTab = this.formData.productGroupOptionArray.length - 1
    },
    markAsDeleted: function (index) {
      this.formData.productGroupOptionArray[index].product_group_option_delete_status = 1
      this.$forceUpdate()
    },
    updateOrder: function () {
      this.formData.productGroupOptionArray.forEach((option, index) => {
        option.product_group_option_order = index + 1
      })
    },
    add_product_option: function () {
      let lastOrder = 0
      let optionArray

      if (this.formData.productOptionStatus === '0') {
        optionArray = this.formData.productOptionArray
      } else if (this.formData.productOptionStatus === '1' && this.statusData.selectedTab !== null) {
        optionArray = this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      } else {
        alert('그룹 옵션에서 그룹 리스트를 선택해주세요.')
        return
      }

      if (optionArray.length > 0) {
        lastOrder = Math.max(...optionArray.map(option => option.product_option_order))
      }

      const newOption = {
        option_list_num: 0,
        product_option_ID: 0,
        product_ID_use_product_option: 0,
        product_option_name: '',
        product_option_name_error: '',
        product_option_order: lastOrder + 1,
        product_option_order_error: '',
        product_option_delete_status: 0,
        product_option_list: []
      }

      optionArray.push(newOption)
      this.statusData.productOptionIndex++

      this.$nextTick(() => {
        const elementId = `product_option_name${optionArray.length - 1}`
        const inputElement = document.getElementById(elementId)
        if (inputElement) {
          inputElement.focus()
        }
      })
    },
    delete_product_option: function (index) {
      let optionArray = this.formData.productOptionStatus === '0' ? this.formData.productOptionArray : this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      if (index !== -1) {
        optionArray[index] = {
          ...optionArray[index],
          product_option_delete_status: 1
        }
        optionArray = [...optionArray]
      }
      this.$forceUpdate()
    },
    add_product_option_list: function (index) {
      let optionArray = this.formData.productOptionStatus === '0' ? this.formData.productOptionArray : this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      const option = optionArray[index]
      if (!option) {
        alert('옵션이 없습니다.')
        return
      }
      let lastOrder = 0
      if (option.product_option_list.length > 0) {
        lastOrder = Math.max(...option.product_option_list.map(list => list.product_option_list_order))
      }
      const newListIndex = option.product_option_list.length
      const newOptionList = {
        product_option_list_ID: 0,
        product_option_ID_use_product_option_list: 0,
        product_option_list_name: '',
        product_option_list_name_error: '',
        product_option_list_order: lastOrder + 1,
        product_option_list_order_error: '',
        product_option_list_plus_sale_price: 0,
        product_option_list_plus_sale_price_error: '',
        product_option_list_delete_status: 0
      }
      option.product_option_list.push(newOptionList)
      this.$forceUpdate()
      this.$nextTick(() => {
        const element = this.$el.querySelector(`#product_option_list_plus_sale_price${newListIndex}${index}`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },
    delete_product_option_list: function (index, listIndex) {
      let optionArray = this.formData.productOptionStatus === '0' ? this.formData.productOptionArray : this.formData.productGroupOptionArray[this.statusData.selectedTab].product_option
      const option = optionArray[index]
      if (option) {
        const list = option.product_option_list[listIndex]
        if (list) {
          list.product_option_list_delete_status = 1
        } else {
          alert('삭제할 리스트 항목을 찾을 수 없습니다.')
        }
      } else {
        alert('해당하는 옵션을 찾을 수 없습니다.')
      }
      this.$forceUpdate()
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.productKorName === '') {
        this.errorData.productKorNameError = '제품 한글명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productKorNameError = ''
      }
      if (this.formData.productEngName === '') {
        this.errorData.productEngNameError = '제품 영문명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productEngNameError = ''
      }
      if (this.formData.productInventory === '') {
        this.errorData.productInventoryError = '재고 수량을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productInventoryError = ''
      }
      if (this.formData.productSalePrice === '') {
        this.errorData.productSalePriceError = '제품 가격을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productSalePriceError = ''
      }
      if (this.formData.productDiscount === '') {
        this.errorData.productDiscountError = '할인금액을 입력해 주세요.(없으면 0으로)'
        continue_add = false
      } else {
        this.errorData.productDiscountError = ''
      }
      if (this.formData.productImage === '') {
        this.errorData.productImageError = '제품 이미지를 넣어주세요.'
        continue_add = false
      } else {
        this.errorData.productImageError = ''
      }
      if (this.formData.productImageDetail === '') {
        this.errorData.productImageDetailError = '상세 페이지 이미지1을 넣어주세요.'
        continue_add = false
      } else {
        this.errorData.productImageDetailError = ''
      }
      if (this.formData.productImageDetail2 === '') {
        this.errorData.productImageDetail2Error = '상세 페이지 이미지2을 넣어주세요.'
        continue_add = false
      } else {
        this.errorData.productImageDetail2Error = ''
      }
      if (
        this.formData.productOptionStatus === '1' &&
        this.formData.productGroupOptionTitle === ''
      ) {
        this.errorData.productGroupOptionTitleError = '그룹 옵션명을 입력해주세요.'
        continue_add = false
      } else {
        this.errorData.productGroupOptionTitleError = ''
      }

      const checkOptions = (optionArray) => {
        let local_continue_add = true
        for (const element of optionArray) {
          if (element.product_option_delete_status === 0) {
            if (element.product_option_name === '') {
              element.product_option_name_error = '옵션명을 입력해 주세요.'
              local_continue_add = false
            } else {
              element.product_option_name_error = ''
            }
            if (element.product_option_order === '') {
              element.product_option_order_error = '순서를 입력해 주세요.'
              local_continue_add = false
            } else {
              element.product_option_order_error = ''
            }
            for (const element_option_list of element.product_option_list) {
              if (element_option_list.product_option_list_delete_status === 0) {
                if (element_option_list.product_option_list_name === '') {
                  element_option_list.product_option_list_name_error = '리스트명을 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.product_option_list_name_error = ''
                }
                if (element_option_list.product_option_list_order === '') {
                  element_option_list.product_option_list_order_error = '순서를 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.product_option_list_order_error = ''
                }
                if (element_option_list.product_option_list_plus_sale_price === '') {
                  element_option_list.product_option_list_plus_sale_price_error = '추가 금액을 입력해 주세요.'
                  local_continue_add = false
                } else {
                  element_option_list.product_option_list_plus_sale_price_error = ''
                }
              }
            }
          }
        }
        return local_continue_add
      }

      if (this.formData.productOptionStatus === '0') {
        continue_add = checkOptions(this.formData.productOptionArray) && continue_add
      } else if (this.formData.productOptionStatus === '1') {
        for (let i = 0; i < this.formData.productGroupOptionArray.length; i++) {
          this.statusData.selectedTab = i
          if (this.formData.productGroupOptionArray[i].product_group_option_delete_status === 0) {
            let local_continue_add = checkOptions(this.formData.productGroupOptionArray[i].product_option)
            if (!local_continue_add) {
              alert(`그룹 옵션 "${this.formData.productGroupOptionArray[i].product_group_option_name}"에서 문제를 발견했습니다. 해당 탭으로 이동합니다.`)
              this.$forceUpdate()
              return
            }
          }
        }
      }

      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.product_ID === undefined) {
          insert_product(
            this.formData.brandID,
            this.formData.productTypeID,
            this.formData.productDivisionOneLevelID,
            this.formData.productDivisionTwoLevelID,
            this.formData.productInventory,
            this.formData.productKorName,
            this.formData.productEngName,
            this.formData.productNoteTile,
            this.formData.productVideoFile,
            this.formData.productVideoFile2,
            this.formData.productImageFile,
            this.formData.productImageHoverFile,
            this.formData.productImageDetailFile,
            this.formData.productImageDetailFile2,
            this.formData.productSalePrice,
            this.formData.productDiscount,
            this.formData.productPhoneInquiryStatus,
            this.formData.productActivate,
            this.formData.productEvent,
            this.formData.productNew,
            this.formData.productInStock,
            this.formData.productBest,
            this.formData.productSale,
            this.formData.productExpected,
            this.formData.productSoldOut,
            this.formData.productOptionStatus,
            this.formData.productGroupOptionTitle,
            this.formData.productGroupOptionArray,
            this.formData.productOptionArray
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            this.$router.push({
              path: '/AdminProductManagement',
              query: {
                brand_ID_product: this.formData.brandID,
                product_division_one_level_ID_product: this.formData.productDivisionOneLevelID
              }
            })
          })
        } else {
          update_product(
            this.$route.query.product_ID,
            this.formData.brandID,
            this.formData.productTypeID,
            this.formData.productDivisionOneLevelID,
            this.formData.productDivisionTwoLevelID,
            this.formData.productInventory,
            this.formData.productKorName,
            this.formData.productEngName,
            this.formData.productNoteTile,
            this.formData.productVideoFile,
            this.formData.productVideoFile2,
            this.formData.productImageFile,
            this.formData.productImageHoverFile,
            this.formData.productImageDetailFile,
            this.formData.productImageDetailFile2,
            this.formData.productSalePrice,
            this.formData.productDiscount,
            this.formData.productPhoneInquiryStatus,
            this.formData.productActivate,
            this.formData.productEvent,
            this.formData.productNew,
            this.formData.productInStock,
            this.formData.productBest,
            this.formData.productSale,
            this.formData.productExpected,
            this.formData.productSoldOut,
            this.formData.productOptionStatus,
            this.formData.productGroupOptionTitle,
            this.formData.productGroupOptionArray,
            this.formData.productOptionArray
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            this.$router.push({
              path: '/AdminProductManagement',
              query: {
                brand_ID_product: this.formData.brandID,
                product_division_one_level_ID_product: this.formData.productDivisionOneLevelID
              }
            })
          })
        }
      } else {
        this.$forceUpdate()
        alert('필수 입력값을 확인해 주세요.')
      }
    }
  },

  mounted () {
    get_product_select_all().then((result_select) => {
      this.statusData.brandIDArray = result_select.brand_rows
      this.formData.brandID = result_select.brand_rows[0].brand_ID
      this.statusData.productTypeIDArray = result_select.product_type_rows
      this.formData.productTypeID = result_select.product_type_rows[0].product_type_ID

      if (this.$route.query.product_ID !== undefined) {
        get_product_one(this.$route.query.product_ID).then((result_product) => {
          this.formData.brandID = result_product[0].brand_ID_product
          this.formData.productTypeID = result_product[0].product_type_ID_product
          this.formData.productInventory = String(result_product[0].product_inventory).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.productKorName = result_product[0].product_kor_name
          this.formData.productEngName = result_product[0].product_eng_name
          this.formData.productNoteTile = result_product[0].product_note_title
          this.formData.productVideo = result_product[0].product_video
          this.formData.productVideo2 = result_product[0].product_video_2
          this.formData.productImage = result_product[0].product_image
          this.formData.productImageHover = result_product[0].product_image_hover
          this.formData.productImageDetail = result_product[0].product_image_detail
          this.formData.productImageDetail2 = result_product[0].product_image_detail_2
          this.formData.productSalePrice = String(result_product[0].product_sale_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.productDiscount = String(result_product[0].product_discount).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.formData.productPhoneInquiryStatus = result_product[0].product_phone_inquiry_status
          this.formData.productActivate = result_product[0].product_activate
          this.formData.productEvent = result_product[0].product_event
          this.formData.productNew = result_product[0].product_new
          this.formData.productInStock = result_product[0].product_in_stock
          this.formData.productBest = result_product[0].product_best
          this.formData.productSale = result_product[0].product_sale
          this.formData.productExpected = result_product[0].product_expected
          this.formData.productSoldOut = result_product[0].product_sold_out
          this.formData.productOptionStatus = String(result_product[0].product_option_status)
          this.formData.productGroupOptionTitle = result_product[0].product_group_option_title
          if (result_product[0].product_option_status === 0) {
            get_product_option(
              this.$route.query.product_ID,
              0
            ).then((result_product_option) => {
              this.statusData.productOptionIndex = result_product_option.length
              this.formData.productOptionArray = result_product_option
              get_product_option_list(
                this.$route.query.product_ID,
                0
              ).then((result_product_option_list) => {
                this.formData.productOptionArray.forEach(element => {
                  element.product_option_list = []
                  result_product_option_list.forEach(element_option_list => {
                    if (element.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                      element.product_option_list.push(element_option_list)
                    }
                  })
                })
              })
            })
          } else {
            get_product_group_option(
              this.$route.query.product_ID
            ).then((result_product_group_option) => {
              this.statusData.productGroupOptionIndex = result_product_group_option.length
              this.formData.productGroupOptionArray = result_product_group_option

              const promises = result_product_group_option.map(async (groupOption, index) => {
                return get_product_option(
                  this.$route.query.product_ID,
                  groupOption.product_group_option_ID
                ).then((result_product_option) => {
                  this.$set(this.formData.productGroupOptionArray[index], 'product_option', result_product_option)
                  this.statusData.productOptionIndex += result_product_option.length

                  const listPromises = result_product_option.map((option, optionIndex) => {
                    return get_product_option_list(
                      this.$route.query.product_ID,
                      groupOption.product_group_option_ID
                    ).then((result_product_option_list) => {
                      this.$set(this.formData.productGroupOptionArray[index].product_option[optionIndex], 'product_option_list', [])
                      result_product_option_list.forEach(element_option_list => {
                        if (option.product_option_ID === element_option_list.product_option_ID_use_product_option_list) {
                          this.formData.productGroupOptionArray[index].product_option[optionIndex].product_option_list.push(element_option_list)
                        }
                      })
                    })
                  })
                  return Promise.all(listPromises)
                })
              })
              Promise.all(promises)
            })
          }
          get_product_division_one_level_one_product_type(
            result_product[0].product_type_ID_product
          ).then((result_division_one) => {
            this.statusData.productDivisionOneLevelIDArray = result_division_one
            this.formData.productDivisionOneLevelID = result_product[0].product_division_one_level_ID_product
            get_product_division_two_level_one_product_division_one_level(
              result_product[0].product_division_one_level_ID_product
            ).then((result_division_two) => {
              if (result_division_two.length !== 0) {
                this.statusData.productDivisionTwoLevelIDArray = result_division_two
                this.formData.productDivisionTwoLevelID = result_product[0].product_division_two_level_ID_product
              } else {
                this.statusData.productDivisionTwoLevelIDArray = []
                this.formData.productDivisionTwoLevelID = 0
              }
            })
          })
        })
      } else {
        get_product_division_one_level_one_product_type(
          this.formData.productTypeID
        ).then((result_division_one) => {
          this.statusData.productDivisionOneLevelIDArray = result_division_one
          this.formData.productDivisionOneLevelID = result_division_one[0].product_division_one_level_ID
          get_product_division_two_level_one_product_division_one_level(
            result_division_one[0].product_division_one_level_ID
          ).then((result_division_two) => {
            if (result_division_two.length !== 0) {
              this.statusData.productDivisionTwoLevelIDArray = result_division_two
              this.formData.productDivisionTwoLevelID = result_division_two[0].product_division_two_level_ID
            }
          })
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminProductManagementAdd.vue